var map = {
	"./v0.png": 428,
	"./v1.png": 429,
	"./v2.png": 430,
	"./v3.png": 431,
	"./v4.png": 432,
	"./v5.png": 433,
	"./v6.png": 434,
	"./v7.png": 435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427;